import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mold-header table_90 f-12"
};
const _hoisted_2 = {
  class: "mold-header"
};
const _hoisted_3 = {
  class: "bg_white table_90 m-t-10 border-r-10 text-black f-12"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "green"
};
const _hoisted_6 = {
  key: 1,
  class: "yellow"
};
const _hoisted_7 = {
  key: 2,
  class: "red"
};
const _hoisted_8 = {
  key: 3,
  class: "gray"
};
const _hoisted_9 = {
  class: "page-totle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form = _resolveComponent("el-form");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_button = _resolveComponent("vxe-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      inline: true,
      model: $data.formInline,
      class: "demo-form-inline"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具名称",
            "label-width": "85px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.matrix_title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formInline.matrix_title = $event),
              placeholder: "请输入单个模具名称",
              maxlength: "60",
              style: {
                "width": "100%"
              },
              oninput: "value=value.replace(/[^A-Za-z0-9\\u4e00-\\u9fa5]/g,'')",
              onKeydown: _cache[1] || (_cache[1] = _withKeys($event => $options.findList(1), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "半成品物料编码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.produce_sn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formInline.produce_sn = $event),
              placeholder: "请输入单个半成品物料编码或名称",
              maxlength: "60",
              style: {
                "width": "100%"
              },
              onKeydown: _cache[3] || (_cache[3] = _withKeys($event => $options.findList(1), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "成品规格型号",
            "label-width": "90px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.produce_sku,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formInline.produce_sku = $event),
              placeholder: "请输入单个成品规格型号",
              onKeydown: _cache[5] || (_cache[5] = _withKeys($event => $options.findList(1), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具类型",
            "label-width": "75px",
            prop: "region"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.type,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formInline.type = $event),
              filterable: "",
              placeholder: "全部",
              style: {
                "width": "100%"
              },
              onKeydown: _cache[7] || (_cache[7] = _withKeys($event => $options.findList(1), ["enter"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "全部",
                value: "0"
              }), _createVNode(_component_el_option, {
                label: "塑胶注塑模",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "五金模",
                value: "2"
              }), _createVNode(_component_el_option, {
                label: "硅胶模",
                value: "3"
              }), _createVNode(_component_el_option, {
                label: "线材模",
                value: "4"
              }), _createVNode(_component_el_option, {
                label: "铝挤型材模",
                value: "5"
              }), _createVNode(_component_el_option, {
                label: "金属铸造模",
                value: "6"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "有无复制模",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.is_copy_matrix,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formInline.is_copy_matrix = $event),
              filterable: "",
              placeholder: "全部",
              style: {
                "width": "120%"
              },
              onKeydown: _cache[9] || (_cache[9] = _withKeys($event => $options.findList(1), ["enter"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "全部",
                value: "0"
              }), _createVNode(_component_el_option, {
                label: "无",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "有，供应商所有",
                value: "2"
              }), _createVNode(_component_el_option, {
                label: "有，我司所有",
                value: "3"
              }), _createVNode(_component_el_option, {
                label: "复制模",
                value: "4"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "申请开模时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formInline.matrix_start,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.formInline.matrix_start = $event),
              format: "YYYY/MM/DD",
              "value-format": "YYYY-MM-DD",
              type: "date",
              placeholder: "年/月/日",
              style: {
                "width": "90%"
              },
              onKeydown: _cache[11] || (_cache[11] = _withKeys($event => $options.findList(1), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模完成时间",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: $data.formInline.matrix_finish,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.formInline.matrix_finish = $event),
              type: "date",
              format: "YYYY/MM/DD",
              "value-format": "YYYY-MM-DD",
              placeholder: "年/月/日",
              "disabled-date": _ctx.disabledDate,
              shortcuts: _ctx.shortcuts,
              style: {
                "width": "93%"
              },
              onKeydown: _cache[13] || (_cache[13] = _withKeys($event => $options.findList(1), ["enter"]))
            }, null, 8, ["modelValue", "disabled-date", "shortcuts"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "开模申请人",
            onKeydown: _cache[15] || (_cache[15] = _withKeys($event => $options.findList(1), ["enter"])),
            "label-width": "90px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.matrix_apply,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.formInline.matrix_apply = $event),
              placeholder: "开模申请人",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具供应商",
            onKeydown: _cache[17] || (_cache[17] = _withKeys($event => $options.findList(1), ["enter"]))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.supplier,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.formInline.supplier = $event),
              placeholder: "模具供应商",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "物料生产供应商",
            onKeydown: _cache[19] || (_cache[19] = _withKeys($event => $options.findList(1), ["enter"]))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.formInline.produc_supplier,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.formInline.produc_supplier = $event),
              placeholder: "物料生产供应商",
              style: {
                "width": "120%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模具状态",
            "label-width": "84px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: $data.formInline.status,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.formInline.status = $event),
              filterable: "",
              placeholder: "全部",
              style: {
                "width": "92%"
              },
              onKeydown: _cache[21] || (_cache[21] = _withKeys($event => $options.findList(1), ["enter"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "全部",
                value: "0"
              }), _createVNode(_component_el_option, {
                label: "正常",
                value: "1"
              }), _createVNode(_component_el_option, {
                label: "不佳",
                value: "2"
              }), _createVNode(_component_el_option, {
                label: "修模",
                value: "3"
              }), _createVNode(_component_el_option, {
                label: "报废",
                value: "4"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 5
        }), _createVNode(_component_el_col, {
          span: 13,
          class: "u-t-r"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[22] || (_cache[22] = $event => $options.findList(1))
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("搜索")])),
            _: 1,
            __: [25]
          }), _createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            onClick: _cache[23] || (_cache[23] = $event => $options.reset())
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("重置")])),
            _: 1,
            __: [26]
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.addClick
  }, {
    default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("新增")])),
    _: 1,
    __: [27]
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[24] || (_cache[24] = $event => _ctx.debounceMethods($options.findList, 2))
  }, {
    default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("导出")])),
    _: 1,
    __: [28]
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_vxe_table, {
    border: "",
    height: "450",
    data: $data.tableColumn,
    "empty-text": "没有更多数据了！",
    ref: "xTable1",
    "show-overflow": $data.showOverflow1,
    "export-config": {}
  }, {
    default: _withCtx(() => [_createVNode(_component_vxe_column, {
      field: "matrix_sn",
      dir: "",
      fixed: "left",
      align: "center",
      title: "模具编号",
      width: "150"
    }, {
      default: _withCtx(({
        row
      }) => [_createElementVNode("span", {
        onClick: $event => $options.addEdit(row.id),
        class: "cus-point"
      }, _toDisplayString(row.matrix_sn), 9, _hoisted_4)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "matrix_title",
      fixed: "left",
      title: "模具名称",
      width: "280"
    }), _createVNode(_component_vxe_column, {
      field: "produce_sn",
      title: "半成品物料编码",
      width: "150"
    }), _createVNode(_component_vxe_column, {
      field: "produce_sku",
      title: "成品规格型号（sku）",
      width: "280"
    }), _createVNode(_component_vxe_column, {
      field: "type_name",
      title: "模具类型",
      width: "100",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      field: "is_copy_matrix_name",
      title: "有无复制模",
      width: "100",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      field: "cost_price",
      title: "模具费用",
      width: "100",
      align: "right"
    }), _createVNode(_component_vxe_column, {
      field: "return_standard",
      title: "模具费返还标准（万次）",
      width: "110",
      align: "right"
    }), _createVNode(_component_vxe_column, {
      field: "matrix_start",
      title: "申请开模时间",
      width: "110"
    }), _createVNode(_component_vxe_column, {
      field: "matrix_finish",
      title: "开模完成时间",
      width: "110"
    }), _createVNode(_component_vxe_column, {
      field: "matrix_life",
      title: "模具设计寿命（万次）",
      width: "110"
    }), _createVNode(_component_vxe_column, {
      field: "holes_num",
      title: "模具穴数",
      width: "83"
    }), _createVNode(_component_vxe_column, {
      field: "capacity_num",
      title: "模具产能（每小时）",
      width: "100"
    }), _createVNode(_component_vxe_column, {
      field: "matrix_apply",
      title: "开模申请人",
      width: "100",
      align: "center"
    }), _createVNode(_component_vxe_column, {
      field: "supplier",
      title: "模具供应商",
      width: "150"
    }), _createVNode(_component_vxe_column, {
      field: "produc_supplier",
      title: "物料生产供应商",
      width: "150"
    }), _createVNode(_component_vxe_column, {
      field: "status_name",
      title: "模具状态",
      width: "83",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [row.status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.status_name), 1)) : row.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.status_name), 1)) : row.status == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.status_name), 1)) : row.status == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.status_name), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "agreement",
      title: "模具保管协议",
      width: "105",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [row.agreement == '' ? (_openBlock(), _createBlock(_component_vxe_button, {
        key: 0,
        disabled: "",
        status: "info"
      }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("下载")])),
        _: 1,
        __: [29]
      })) : (_openBlock(), _createBlock(_component_vxe_button, {
        key: 1,
        onClick: $event => $options.getDownload(row.agreement),
        status: "primary"
      }, {
        default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("下载")])),
        _: 2,
        __: [30]
      }, 1032, ["onClick"]))]),
      _: 1
    }), _createVNode(_component_vxe_column, {
      field: "remark",
      title: "备注",
      width: "280"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
        effect: "dark",
        content: scope.row.remark,
        placement: "top",
        disabled: scope.row.remark.length > 30
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row.remark), 1)]),
        _: 2
      }, 1032, ["content", "disabled"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "show-overflow"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_pagination, {
    "current-page": $data.formInline.page,
    "page-sizes": [10, 20, 30],
    "page-size": $data.formInline.size,
    layout: "total, sizes, prev, pager, next, jumper",
    total: _ctx.count,
    class: "m-t-10 m-b-20 table_90",
    onSizeChange: $options.handleSizeChange,
    onCurrentChange: $options.handleCurrentChange
  }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])])])]);
}